import { createSelector } from '@reduxjs/toolkit';
import { toVehicleAdjustmentLog, toVehicleAdjustRetail } from 'modules/core/utils';
import { IVehicleDetails } from 'components/Modals/VehicleDetailsDialog/types';
import { ICreateUserVehicle } from 'components/Modals/AddVehicleDialog/types';
import { TableName } from 'modules/core/enums';
import { IRequestFlags } from 'modules/core/types';

import { RootState } from '../store';
import { IVehicleReducerState } from '../reducers/vehicle.reducer';

export const getVehicleState = (state: RootState): IVehicleReducerState => state.vehicle;

export const getVehicleDetails = (state: RootState): IVehicleDetails | undefined =>
  getVehicleState(state).vehicleDetails;

export const getDefaultVehiclePhoto = (state: RootState): string => getVehicleState(state).defaultVehiclePhoto;

export const getAdjustmentId = (state: RootState): number => getVehicleState(state).adjustmentId;

export const getPassengerCapacities = (state: RootState): number[] => getVehicleState(state).passengerCapacities;

export const getVehicleAdjustRetail = createSelector(getVehicleState, toVehicleAdjustRetail);

export const getVehicleAdjustmentLog = createSelector(getVehicleState, toVehicleAdjustmentLog);

export const getAddUserVehicleFlags = (state: RootState): IRequestFlags => {
  const { addUserVehicleFlags } = getVehicleState(state);

  return { ...addUserVehicleFlags };
};

export const getUpdateUserVehicleFlags = (state: RootState): IRequestFlags => {
  const { updateUserVehicleFlags } = getVehicleState(state);

  return { ...updateUserVehicleFlags };
};

export const getDeleteUserVehicleFlags = (state: RootState): IRequestFlags => {
  const { deleteUserVehicleFlags } = getVehicleState(state);

  return { ...deleteUserVehicleFlags };
};

export const getCreatedUserVehicle = (state: RootState): ICreateUserVehicle =>
  getVehicleState(state).createdUserVehicle;

export const getCreatedUserVehicleTableName = (state: RootState): TableName | null =>
  getVehicleState(state).createdUserVehicleTableName;

export const getCreatedUserVehicleLenderId = (state: RootState): string | null =>
  getVehicleState(state).createdUserVehicleLenderId;

export const getAddedIsUserVehicle = (state: RootState): boolean => getVehicleState(state).addedIsUserVehicle;

export const getIsDealSourceVehicle = (state: RootState): boolean => getVehicleState(state).isDealSourceVehicle;
